import { Component, OnInit }       from '@angular/core';
import { Params, Router } from '@angular/router';
import { Location }        from '@angular/common';

import { CallService } from '../services/calls/call.service';
import { ReportService } from '../services/reports/report.service';

import { StatusCallsComponent } from './statusCalls.component'
import { ProviderService } from '../services/providers/provider.service';


import * as _ from 'lodash';

import * as moment from 'moment';


@Component({
  moduleId: module.id,
  selector: 'hours-calls',
  templateUrl: 'hourCall.component.html',
  styleUrls: [ '../users/users.component.css' ]
})

export class HourCallsComponent extends StatusCallsComponent{

  constructor(protected callService: CallService,
    protected location: Location,
    protected router: Router,
    protected infoService: ReportService,
  protected providerService:ProviderService) {
        super(callService,location,router,infoService,providerService);
}

infoName='callFee'

}



// WEBPACK FOOTER //
// ./src/app/calls/hourCall.component.ts